// src/actions/templates.js
import {client} from "../axios/client";
import {types} from "../types/types";

export const getTemplates = (id_customer, token, offset = 0, limit = 5, name = null, category = null, all=false) => {
    return async (dispatch) => {
        try {
            const {data} = await client.get(`/templates/${id_customer}`, {
                headers: {'Authorization': `Bearer ${token}`},
                params: {offset, limit, name, category,all}
            });
            dispatch(setTemplates({templates: data}));
            return data; // permite obtener los items en el componente
        } catch (error) {
            console.error('Error obteniendo templates:', error);
            return {items: []};
        }
    };
};


export const setTemplates = (templates) => ({
    type: types.templatesGet,
    payload: templates
})

/**
 * Elimina un template por nombre
 */
export const deleteTemplate = ({name, username, apiKey}) => {
    return async (dispatch) => {
        try {
            const BASE_URL = process.env.REACT_APP_TEMPLATE_DELIVERY_SERVICE_URI;

            if (!BASE_URL) {
                throw new Error("TEMPLATE_DELIVERY_SERVICE_URI no está configurada");
            }
            const DELETE_URL = `${BASE_URL}/api/templates/${encodeURIComponent(name)}?username=${encodeURIComponent(
                username
            )}&api_key=${encodeURIComponent(apiKey)}`;
            const res = await fetch(DELETE_URL, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (!res.ok) {
                const errorText = await res.text();
                throw new Error(errorText || "Error creando template");
            }
            const data = await res.json().catch(() => ({}));
            return {
                success: true,
                data,
            };

        } catch (error) {
            console.error("Error eliminando template:", error);
            return {
                success: false,
                error: error.message || "No se pudo eliminar la plantilla",
            };

        }
    };
};

export const removeTemplate = (name) => ({
    type: types.templatesDelete,
    payload: name,
});

/**
 * Obtener template por ID via API principal
 */
export const getTemplateById = async (templateId, token) => {
    try {
        const { data } = await client.get(`/templates/single/${templateId}`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return data;
    } catch (error) {
        console.error('Error obteniendo template por ID:', error);
        return null;
    }
};

export const getTemplateClones = async (id_customer, token, template_id, offset = 0, limit = 20) => {
    try {
        const { data } = await client.get(`/templates/${template_id}/clones`, {
            headers: { Authorization: `Bearer ${token}` },
            params: { offset, limit }
        });
        return data; // { original: {...}, clones: { items: [], offset, count, limit } }
    } catch (error) {
        console.error('Error obteniendo clones del template:', error);
        return null;
    }
};

/**
 * Clonar template via Template Delivery Service
 */
export const cloneTemplate = ({ templateId, username, apiKey, payload }) => {
    return async () => {
        try {
            const BASE_URL = process.env.REACT_APP_TEMPLATE_DELIVERY_SERVICE_URI;

            if (!BASE_URL) {
                throw new Error("TEMPLATE_DELIVERY_SERVICE_URI no esta configurada");
            }

            const POST_URL = `${BASE_URL}/api/templates/clone/${encodeURIComponent(templateId)}?username=${encodeURIComponent(username)}&api_key=${encodeURIComponent(apiKey)}`;

            const res = await fetch(POST_URL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            if (!res.ok) {
                const errorText = await res.text();
                let detail = errorText;
                try {
                    const parsed = JSON.parse(errorText);
                    detail = parsed.detail || parsed.error || errorText;
                } catch {}
                throw new Error(detail);
            }

            const data = await res.json().catch(() => ({}));

            return {
                success: true,
                data,
            };
        } catch (error) {
            console.error("Error clonando template:", error);

            return {
                success: false,
                error: error.message || "No se pudo clonar el template",
            };
        }
    };
};

/**
 * Crear template en Gupshup (Template Delivery Service)
 */
export const createTemplate = ({payload, username, apiKey}) => {
    return async () => {
        try {
            const BASE_URL = process.env.REACT_APP_TEMPLATE_DELIVERY_SERVICE_URI;

            if (!BASE_URL) {
                throw new Error("TEMPLATE_DELIVERY_SERVICE_URI no está configurada");
            }

            const POST_URL = `${BASE_URL}/api/templates/create-template?username=${encodeURIComponent(
                username
            )}&api_key=${encodeURIComponent(apiKey)}`;

            const res = await fetch(POST_URL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            if (!res.ok) {
                const errorText = await res.text();
                throw new Error(errorText || "Error creando template");
            }

            const data = await res.json().catch(() => ({}));

            return {
                success: true,
                data,
            };
        } catch (error) {
            console.error("❌ Error creando template:", error);

            let errorMsg = error.message || "No se pudo crear el template";
            try {
                const parsed = JSON.parse(errorMsg);
                errorMsg = parsed.detail || parsed.error || errorMsg;
            } catch {}

            return {
                success: false,
                error: errorMsg,
            };
        }
    };
};
